import { FaFacebookF,FaInstagram } from "react-icons/fa6";
import { FaYoutube, FaLinkedin  } from "react-icons/fa";
import {AiOutlineWhatsApp} from 'react-icons/ai';
export const iconList = {
    FaFacebookF,
    FaInstagram ,
    FaYoutube ,
    FaLinkedin ,
    AiOutlineWhatsApp
};